import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PtBr from '../pages/ptBr/home';
import New from '../pages/ptBr/new';
import Follow from '../pages/ptBr/follow';
import Relato from '../pages/ptBr/relato';
import Sucess from '../pages/ptBr/sucess';
import PrivateRoute from './privateRoute';
import Login from '../pages/admin/login';
import { Relato as RelatoAdmin}  from '../pages/admin/relato';
import Relatos from '../pages/admin/relatos';
import NotFound from '../pages/ptBr/404';
import HomeEn from '../pages/enUs/home';
import FollowEn from '../pages/enUs/follow';
import RelatoEn from '../pages/enUs/relato';
import NewEn from '../pages/enUs/new';
import SucessEn from '../pages/enUs/sucess';
import HomeEsp from '../pages/esp/home';
import FollowEsp from '../pages/esp/follow';
import SucessEsp from '../pages/esp/sucess';
import RelatoEsp from '../pages/esp/relato';
import NewEsp from '../pages/esp/new';

export default function AppRoutes(params) {
  return (
    <BrowserRouter>
      <Routes>
        <Route >
          <Route index element={<PtBr />} />
          <Route path='/new' element={<New />} />
          <Route path='/follow' element={<Follow />} />
          <Route path='/acompanhar' element={<Relato />} />
          <Route path='/sucess' element={<Sucess />} />
          <Route path='/login' element={<Login />} />
          {/* ingles */}
          <Route path='/en/home' element={<HomeEn/>}/>
          <Route path='/en/follow' element={<FollowEn/>}/>
          <Route path='/en/sucess' element={<SucessEn/>}/>
          <Route path='/en/report' element={<RelatoEn/>}/>
          <Route path='/en/new' element={<NewEn/>}/>
          {/* Espanhol */}
          <Route path='/es/inicial' element={<HomeEsp/>}/>
          <Route path='/es/consultar' element={<FollowEsp/>}/>
          <Route path='/es/sucesso' element={<SucessEsp/>}/>
          <Route path='/es/acompanhar' element={<RelatoEsp/>}/>
          <Route path='/es/novo' element={<NewEsp/>}/>
          <Route path='/*' element={<NotFound/>}/>
          <Route element={<PrivateRoute />} >
            <Route path='/relatos' element={<Relatos />} />
            <Route path='/relatos/relato' element={<RelatoAdmin />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
};

